export enum OrderStatus {
  PENDING = "PENDING",
  PAID = "PAID",
  PROCESSING = "PROCESSING",
  PAYMENT_ON_DELIVERY = "PAYMENT_ON_DELIVERY",
  IN_PRODUCTION = "IN_PRODUCTION",
  SHIPPED = "SHIPPED",
  DELIVERED = "DELIVERED",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
  REFUNDED = "REFUNDED",
  PARTIALLY_REFUNDED = "PARTIALLY_REFUNDED",
  PROMOTIONAL = "PROMOTIONAL",
}
